import React from "react";

export const DataManagement = React.lazy(
  () => import("@/features/data-management/pages/DataManagementPage.tsx"),
);

export const DataDetail = React.lazy(
  () => import("@/features/data-management/pages/DataDetailPage.tsx"),
);
